class CartDrawerWishlist {
  constructor() {
    this.cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!this.cartDrawer) return;

    this.swymCallbacks = [];
    this.init();
  }

  init() {
    this.setupMoveToWishlistButtons();
    this.setupCartDrawerOpenListener();
    this.waitForSwym();
    this.initializeTabs();
  }
  
  queryElements() {
    if (!this.cartDrawer) this.cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!this.cartDrawer) return false;

    this.tabs = this.cartDrawer.querySelectorAll('[data-cart-tab]');
    this.bagContent = this.cartDrawer.querySelector('[data-tab-content="bag"]');
    this.wishlistContent = this.cartDrawer.querySelector('[data-tab-content="wishlist"]');
    this.wishlistContainer = this.cartDrawer.querySelector('[data-wishlist-content]');
    this.wishlistLoading = this.cartDrawer.querySelector('[data-wishlist-loading]');
    this.wishlistEmpty = this.cartDrawer.querySelector('[data-wishlist-empty]');

    return this.bagContent && this.wishlistContent;
  }
  
  initializeTabs() {
    if (this.cartDrawer.querySelectorAll('[data-cart-tab]').length > 0) {
      this.setupTabSwitching();
    }
  }

  setupCartDrawerOpenListener() {
    document.addEventListener('theme:cart:open', () => {
      setTimeout(() => {
        this.initializeTabs();
        this.switchTab('bag');
      }, 100);
    });

    document.addEventListener('theme:cart:openWishlist', () => {
      setTimeout(() => {
        if (this.queryElements()) {
          this.initializeTabs();
          this.switchTab('wishlist');
        }
      }, 150);
    });

    document.querySelectorAll('[data-cart-drawer-toggle]').forEach(button => {
      button.addEventListener('click', () => {
        setTimeout(() => {
          if (this.cartDrawer && !this.cartDrawer.classList.contains('cv-h')) {
            this.initializeTabs();
            this.switchTab('bag');
          }
        }, 150);
      });
    });
  }

  waitForSwym() {
    const checkSwym = () => {
      if (window._swat?.fetch) {
        this.onSwymReady();
      } else {
        setTimeout(checkSwym, 100);
      }
    };
    checkSwym();
  }

  onSwymReady() {
    if (window._swat?.initializeActionButtons) {
      try {
        window._swat.initializeActionButtons();
      } catch (e) {}
    }
    
    this.swymCallbacks.forEach(callback => callback());
    this.swymCallbacks = [];
  }

  whenSwymReady(callback) {
    window._swat?.fetch ? callback() : this.swymCallbacks.push(callback);
  }

  setupTabSwitching() {
    this.tabs = this.cartDrawer.querySelectorAll('[data-cart-tab]');
    
    this.tabs.forEach(tab => {
      if (tab._tabClickListener) {
        tab.removeEventListener('click', tab._tabClickListener);
      }
      
      const listener = (e) => {
        e.preventDefault();
        this.switchTab(e.currentTarget.getAttribute('data-cart-tab'));
      };
      
      tab._tabClickListener = listener;
      tab.addEventListener('click', listener);
    });
  }

  switchTab(tabName) {
    if (!this.queryElements()) return;
    
    this.tabs.forEach(tab => {
      const isActive = tab.getAttribute('data-cart-tab') === tabName;
      tab.classList.toggle('cart-drawer__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    this.loadWishlist();

    if (tabName === 'bag') {
      this.bagContent.classList.remove('hidden');
      this.wishlistContent.classList.remove('active');
      this.wishlistContent.classList.add('hidden');
    } else if (tabName === 'wishlist') {
      this.bagContent.classList.add('hidden');
      this.wishlistContent.classList.add('active');
      this.wishlistContent.classList.remove('hidden');
    }
  }

  loadWishlist() {
    this.wishlistLoading.classList.remove('hidden');
    this.wishlistContainer.innerHTML = '';
    this.wishlistEmpty.classList.add('hidden');

    this.whenSwymReady(() => {
      window._swat.fetch((items) => {
        this.wishlistLoading.classList.add('hidden');
        
        if (!items?.length) {
          this.wishlistEmpty.classList.remove('hidden');
          this.updateWishlistCount(0);
          return;
        }

        this.renderWishlistItems(items);
      });
    });
  }

  renderWishlistItems(items) {
    this.wishlistContainer.innerHTML = '';
    items.forEach(item => {
      this.wishlistContainer.appendChild(this.createWishlistItemElement(item));
    });
    this.setupWishlistItemActions();
    this.updateWishlistCount(items.length);
  }

  updateWishlistCount(count) {
    const wishlistQtyElement = document.querySelector('[data-wishlist-items-qty]');
    if (wishlistQtyElement) {
      if (count > 0) {
        wishlistQtyElement.textContent = `(${count})`;
        wishlistQtyElement.classList.remove('hidden');
      } else {
        wishlistQtyElement.textContent = '';
        wishlistQtyElement.classList.add('hidden');
      }
    }
  }

  createWishlistItemElement(item) {
    const div = document.createElement('div');
    div.className = 'cart__item';
    div.setAttribute('data-wishlist-item', item.epi || item.empi);
    div.setAttribute('data-variant-id', item.epi || item.empi);
    div.setAttribute('data-product-id', item.empi || item.epi);

    const imageUrl = item.iu || item.image_url || '';
    const title = item.dt || item.product_title || '';
    const variantTitle = item.vt || item.variant_title || '';
    const price = this.formatPrice(item.pr || item.price);
    const productUrl = item.du || item.product_url || '';
    const variantId = item.epi || item.empi;
    const isOutfit = imageUrl.includes('/outfit_') || (productUrl && productUrl.includes('/outfit'));

    div.innerHTML = `
      <a href="${productUrl}" class="cart__item__card-link" aria-label="${title}"></a>
      <a href="#" class="cart__item__remove cart__item__remove--wishlist" data-remove-from-wishlist data-variant-id="${variantId}" title="Remove from wishlist" style="position: absolute; top: 8px; right: 8px; z-index: 3;">
        <svg width="9.8" height="9.8" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="currentColor"/>
        </svg>
      </a>
      <div class="cart__item__image">
        <a href="${productUrl}" tabindex="-1" aria-hidden="true">
          <img src="${imageUrl}" alt="${title}" loading="lazy">
        </a>
      </div>
      <div class="cart__item__content">
        <div class="cart__item__content-inner">
          <div class="cart__item__info">
            <p class="cart__item__title">
              <a href="${productUrl}" tabindex="-1" aria-hidden="true" data-product-title>${title}</a>
            </p>
            <p class="cart__item__price" data-price="${item.pr || item.price || 0}">
              ${price}
            </p>
            ${variantTitle && variantTitle !== 'Default Title' ? `
            <div class="cart__item__meta">
              <p class="cart__item__selected-options">
                <span>${variantTitle}</span>
              </p>
            </div>
            ` : ''}
          </div>
        </div>
        ${!isOutfit ? `<div class="cart__item__bottom">
          <quantity-counter class="cart__item__quantity" data-quantity-holder>
            <button type="button" class="cart__item__quantity-minus" data-quantity-minus data-quantity-button title="Decrease quantity">
              <span class="visually-hidden">Decrease</span>
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-minus" viewBox="0 0 192 192"><path d="M30 96h132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </button>

            <input type="number" name="updates[]" id="updates_wishlist_${variantId}" class="cart__item__quantity-field"
              data-quantity-field
              data-quantity-max="9999"
              data-id="${variantId}" value="1"
              title="Quantity" pattern="[0-9]*">

            <button type="button" class="cart__item__quantity-plus" data-quantity-plus data-quantity-button title="Increase quantity">
              <span class="visually-hidden">Increase</span>
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-toggle-plus" viewBox="0 0 192 192"><path d="M30 96h132M96 30v132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </button>
          </quantity-counter>

          <button class="cart__item__remove" data-add-to-cart data-variant-id="${variantId}">
            ${window.theme?.strings?.add_to_cart || 'Add to cart'}
          </button>
        </div>` : ''}
      </div>
    `;

    return div;
  }

  formatPrice(price) {
    if (!price) return '';
    
    const amount = parseFloat(price);
    if (isNaN(amount)) return price;

    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(amount * 100, window.theme?.moneyFormat || '${{amount}}');
    }

    return `$${amount.toFixed(2)}`;
  }

  setupWishlistItemActions() {
    this.wishlistContainer.querySelectorAll('[data-add-to-cart]').forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.addWishlistItemToCart(button);
      });
    });

    this.wishlistContainer.querySelectorAll('[data-remove-from-wishlist]').forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        this.removeFromWishlist(element);
      });
    });

    // Quantity controls for wishlist items
    this.wishlistContainer.querySelectorAll('[data-quantity-minus]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const holder = btn.closest('[data-quantity-holder]');
        if (!holder) return;
        const input = holder.querySelector('[data-quantity-field]');
        if (!input) return;
        const max = parseInt(input.getAttribute('data-quantity-max')) || 9999;
        let val = parseInt(input.value) || 1;
        val = Math.max(1, val - 1);
        if (val > max) val = max;
        input.value = val;
      }, true);
    });

    this.wishlistContainer.querySelectorAll('[data-quantity-plus]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const holder = btn.closest('[data-quantity-holder]');
        if (!holder) return;
        const input = holder.querySelector('[data-quantity-field]');
        if (!input) return;
        const max = parseInt(input.getAttribute('data-quantity-max')) || 9999;
        let val = parseInt(input.value) || 1;
        val = Math.min(max, val + 1);
        input.value = val;
      }, true);
    });
  }

  addWishlistItemToCart(button) {
    const variantId = button.getAttribute('data-variant-id');
    const wishlistItem = button.closest('[data-wishlist-item]');
    const qtyInput = wishlistItem?.querySelector('[data-quantity-field]');
    const quantity = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
    
    button.disabled = true;
    button.textContent = window.theme?.strings?.adding_to_cart || 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add to cart');
      return response.json();
    })
    .then(() => {
      const cartElement = document.querySelector('cart-element');
      if (cartElement?.getCart) {
        cartElement.getCart();
      } else if (window.theme?.cart?.getCart) {
        window.theme.cart.getCart();
      } else {
        document.dispatchEvent(new CustomEvent('cart:update'));
      }
      
      this.whenSwymReady(() => {
        const swymProduct = { epi: parseInt(variantId), empi: parseInt(variantId) };
        window._swat.removeFromWishList(swymProduct, () => {
          window._swat.refreshWishlist?.();
          wishlistItem?.remove();
          
          if (this.wishlistContainer.querySelectorAll('[data-wishlist-item]').length === 0) {
            this.wishlistEmpty.classList.remove('hidden');
          }

          setTimeout(() => this.switchTab('bag'), 500);
        });
      });
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.disabled = false;
      button.textContent = 'Add to Bag';
      alert('Error adding item to cart. Please try again.');
    });
  }

  removeFromWishlist(element) {
    const variantId = element.getAttribute('data-variant-id');
    const wishlistItem = element.closest('[data-wishlist-item]');
    
    element.style.pointerEvents = 'none';
    if (element.querySelector('span')) {
      element.querySelector('span').textContent = 'Removing...';
    }

    this.whenSwymReady(() => {
      const swymProduct = { epi: parseInt(variantId), empi: parseInt(variantId) };

      window._swat.removeFromWishList(swymProduct, () => {
        window._swat.refreshWishlist?.();
        wishlistItem?.remove();
        
        const remainingCount = this.wishlistContainer.querySelectorAll('[data-wishlist-item]').length;
        this.updateWishlistCount(remainingCount);
        
        if (remainingCount === 0) {
          this.wishlistEmpty.classList.remove('hidden');
        }
      });
    });
  }

  setupMoveToWishlistButtons() {
    const handleClick = (event) => {
      const button = event.target.closest('.custom-wishlist-button');
      if (!button) return;
      
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      
      this.addToWishlist(button);
    };
    
    document.addEventListener('click', handleClick, true);
    document.addEventListener('mousedown', handleClick, true);
    
    document.addEventListener('theme:cart:open', () => {
      setTimeout(() => this.updateWishlistButtonStates(), 100);
    });
  }
  
  addToWishlist(button) {
    if (button.disabled) return;

    const productId = button.getAttribute('data-product-id');
    const variantId = button.getAttribute('data-variant-id');
    const swymProduct = {
      epi: parseInt(variantId),
      empi: parseInt(productId),
      du: button.getAttribute('data-product-url'),
      dt: button.getAttribute('data-product-title'),
      iu: button.getAttribute('data-product-image'),
      pr: parseFloat(button.getAttribute('data-product-price')) / 100
    };

    button.disabled = true;

    this.whenSwymReady(() => {
      window._swat.fetch((items) => {
        const isInWishlist = items?.some(item =>
          item.epi === parseInt(variantId) || item.empi === parseInt(variantId)
        );

        const callback = () => {
          button.disabled = false;
          window._swat.refreshWishlist?.();
          setTimeout(() => this.updateWishlistButtonStates(), 500);
        };

        isInWishlist
          ? window._swat.removeFromWishList(swymProduct, callback)
          : window._swat.addToWishList(swymProduct, callback);
      });
    });
  }

  updateWishlistButtonStates() {
    this.whenSwymReady(() => {
      window._swat.fetch((items) => {
        const wishlistVariantIds = items?.map(item =>
          parseInt(item.epi) || parseInt(item.empi)
        ) || [];

        document.querySelectorAll('.custom-wishlist-button').forEach(button => {
          const variantId = parseInt(button.getAttribute('data-variant-id'));
          button.classList.toggle('is-added', wishlistVariantIds.includes(variantId));
        });
      });
    });
  }
}

let cartDrawerWishlistInstance = null;

function initializeCartDrawerWishlist() {
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  if (!cartDrawer || cartDrawerWishlistInstance) return;
  
  cartDrawerWishlistInstance = new CartDrawerWishlist();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCartDrawerWishlist);
} else {
  initializeCartDrawerWishlist();
}

document.addEventListener('theme:cart:loaded', () => {
  setTimeout(() => {
    initializeCartDrawerWishlist();
    window._swat?.initializeActionButtons?.();
  }, 100);
});
